module.exports = __webpack_public_path__ + "img/许可证@2x.10e5b23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/许可证@2x.png
// module id = Nh9K
// module chunks = 3